var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useIcon } from "@react-md/icon";
import InputToggle from "./InputToggle";
/**
 * The `Radio` component is just a wrapper for the `InputToggle` that
 * defaults to reasonable defaults for a radio input.
 */
var Radio = forwardRef(function Radio(_a, ref) {
    var propIcon = _a.icon, props = __rest(_a, ["icon"]);
    var icon = useIcon("radio", propIcon);
    return React.createElement(InputToggle, __assign({}, props, { icon: icon, ref: ref, type: "radio" }));
});
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        Radio.propTypes = {
            id: PropTypes.string.isRequired,
            name: PropTypes.string,
            icon: PropTypes.node,
            value: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.string),
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
        };
    }
    catch (e) { }
}
export default Radio;
//# sourceMappingURL=Radio.js.map